import { MMMode } from '../../api/mmode';
import { SearchSelectOption } from '../../components/SearchSelect';

// 加工模式下拉的选项: 按归属组摊平, 组名作前缀 (例 "激光平面 · 平面加工"), 组名也能搜.
// 组名 = 模板键, 组内是模式值自己的中文名. 参数录入页与参数批量导入共用, 候选与文案来自 useParamKeyOptions.
export function modeSelectOptions(
    groups: { code: string; name: string; modes: MMMode[] }[],
    label: (m: MMMode) => string,
): SearchSelectOption[] {
    return groups.flatMap((g) =>
        g.modes.map((m) => ({
            value: m.value,
            label: `${g.name} · ${label(m)}`,
        })),
    );
}
